export default {
  popularityStatsSales: {
    id: 'product_jp_popularity_stats_sales',
    defaultMessage: '{salesLast7Days, html} in the last 7 days',
  },
  salesLast7Days: {
    id: 'product_jp_sales_last_7_days',
    defaultMessage: '{numberItemsSold} items sold',
  },
}
